import { CONVERT_DIALOG_PRODUCT } from "../consts";

const mydialog = { sourceProductId: 0, targetProductId: 0, open: false, };

export const dialogConvertProduct =  product => ({ type: CONVERT_DIALOG_PRODUCT, payload : product });

export default function convertProductDialogReducer(state = mydialog, { type, payload }) {
   
    const actions = {
        [CONVERT_DIALOG_PRODUCT] : () => ({...payload })
    }

    return actions[type]?.call() || state;
}